import React from 'react';
import css from './Header.module.css';

const Header = props => {
  const { description, dek, title } = props;
  return (
    <div className={css.Section}>
      <div className={css.container}>
        {description && <div className={css.description}>{description}</div>}
        {/* The banner title is the page’s heading, so it is the h1 — every page
            drawing this banner has exactly one, and none of them print another
            h1 in the body below (P25028-106). */}
        <h1 className={css.title}>{title}</h1>
        {dek && <div className={css.dek}>{dek}</div>}
      </div>
    </div>
  );
};

Header.defaultProps = {};

Header.propTypes = {};

export default Header;
